import { ServerDate } from "@eres/core";
import { LocaleValue } from "@eres/core/dist/LocaleValue";
import { LVStrings } from "@my-dld/assets/strings";
import { ContractTerm } from "./contract";

export interface MCContractDetails {
	AgreementCompany: any;
	ManagementContractId?: any;
	ManagementContractTypeId: any;
	ManagementContractActivityId: any;
	ManagementContractValue: any;
	ContractStartDate: string;
	ContractEndDate: string;
	NoOfPayments?: number;
	ContractValue?: number;
	PercentageFee?: number;
	FixedFee?: number;
	Reason?: string;
	IsActivityAccepted: boolean;
	ContractStatusId?: number;

	contractValType: any;
}

export interface Responsibilities {
	DescriptionAr: string;
	DescriptionEn: string;
	IsCompany: boolean;
	ResponsibilityID?: number;
}

export interface MCPaymentDetails {
	BankID: number;
	BankName: number;
	PaymentTypeID: number;
	DueDate: number;
	PayAmount: string;
	ChequeNo: string;
}

export interface MCContractCreateRequest extends MCContractDetails {
	ActionType: number;
	ActiveUserID: number;
	ActiveUserType: number;
	AdditionalTerms: ContractTerm[];
	Responsibilities: Responsibilities[];
	ManagementContractActivityId: number;
	ContractValue: number;
	EjariPropertyId: number[];
	OwnerParticipantID: number;
	Payments: MCPaymentDetails[];
	DocumentTemporaryID?: number;
}

export interface AssociatedPerson {
	BirthDate: ServerDate;
	BirthPlaceAr: string;
	BirthPlaceEn?: any;
	CitizenshipStatus: number;
	CompanyName?: any;
	CountryId: number;
	ESignature: boolean;
	FName?: any;
	FamilyNameAr: string;
	FamilyNameEn: string;
	FileNumber?: any;
	FirstNameAr?: any;
	FirstNameEn?: any;
	Fname?: any;
	IdIssueDate: ServerDate;
	IdNumber: string;
	IdTypeCode: number;
	MiddleName?: any;
	MiddleNameAr?: any;
	Mobile: string;
	NationalityStatus: number;
	OldParticipantId?: any;
	OqoodCountryId?: any;
	ParticipantId: number;
	PassportExpiryDate: ServerDate;
	PassportIssuePlaceAr?: any;
	PassportIssuePlaceEn?: any;
	Profession?: any;
	RegionNumber?: any;
	Remarks?: any;
	ResidencyExpiryDate?: any;
	ResidencyNumber?: any;
	ResidencyStartDate?: any;
	Sex: boolean;
	SponsorTypeId?: any;
	Title?: any;
	UaeIdNumber: string;
	UserPassword?: any;
}

export interface AssociatedParticipant {
	Address: string;
	AllowedDelayedReceipt?: any;
	AllowedDelayedVoucher?: any;
	ApplicationId: number;
	AssociatedAuthority?: any;
	AssociatedPerson: AssociatedPerson;
	CreationDate: ServerDate;
	DBAction: number;
	DevUserName?: any;
	DeveloperId?: any;
	Email: string;
	EmirateId?: any;
	Fax?: any;
	FixI?: any;
	HoldReason?: any;
	Identity: number;
	IsDeleted?: any;
	IsHeld?: any;
	IsHeldBy?: any;
	ModifiedDate: ServerDate;
	NameAr: string;
	NameArFiltered?: any;
	NameEn: string;
	ParticipantNumber: string;
	ParticipantOldIdentifier?: any;
	ParticipantStatus: string;
	ParticipantType: number;
	Phone: string;
	PoBox?: any;
	Username: string;
	Webpage?: any;
}

export interface Owner {
	AssociatedParticipant: AssociatedParticipant;
	Id: number;
	IsPrimary: number;
	IsValid: boolean;
	NamesAr: string;
	NamesEn: string;
	OwnerNumber: string;
	Percentage: number;
	PropertyId: number;
	PropertyRelationStatus: string;
	RelationEndDate?: any;
	RelationStartDate: ServerDate;
	RelationTypeId: number;
}

export interface PropertyUsage {
	DBAction: number;
	Description?: any;
	Identity: number;
	IsActive: number;
	IsDeleted: number;
	IsHousingfee: number;
	NameAr: string;
	NameEn: string;
}


export interface AssociatedDetailedProperty {
	AnnualRent: number;
	BuildingNameAr: string;
	BuildingNameEn: string;
	BuildingPropertyId: number;
	UnitFloorNumber: string;
	UnitId: number;
	UnitNumber: string;
	UnitTypeNameAr?: any;
	UnitTypeNameEn?: any;
	ActualArea: number;
	Address?: any;
	ApprovalRefNo: string;
	AssociatedTenancyContract?: any;
	CoTenantsCount: number;
	ContractPropertyId: number;
	DBAction: number;
	DEWAAccountNo: string;
	DEWAAccountNoDisplayText: string;
	DewaAccNameAr?: any;
	DewaAccNameEn?: any;
	DewaIsCommon: boolean;
	DewaNumberOfRoom: number;
	DewaRefNo?: any;
	DewaSDPaid?: any;
	EjariPropertySubTypeId: number;
	EjariPropertyTypeId: number;
	Identity: number;
	IsNew: number;
	LandAreaId: number;
	LandAreaNameAr: string;
	LandAreaNameEn: string;
	LandBuildingsCount: number;
	LandId: number;
	LandLatitude: number;
	LandLongitude: number;
	LandMunicipalityNumber: number;
	LandMunicipalitySubNumber: number;
	LandNo: string;
	LandPropertyId: number;
	LandSubNo: number;
	LandVillasCount: number;
	LandZoneId: number;
	LandZoneNameAr: string;
	LandZoneNameEn: string;
	MCNumber?: any;
	MakaniNumber?: any;
	ManagementContractId: number;
	NoOfParkings?: any;
	OwnerId: number;
	OwnerIds: number[];
	OwnerIsPrimary: number;
	OwnerNameAr?: any;
	OwnerNameEn?: any;
	OwnerNamesAr: string[];
	OwnerNamesEn: string[];
	OwnerRelationEndDate?: any;
	OwnerRelationPropertyStatus?: any;
	OwnerRelationStartDate?: any;
	OwnerRelationTypeId: number;
	Owners: Owner[];
	OwnersCount: number;
	OwnersStrAr: string;
	OwnersStrEn: string;
	PropertyActualArea: number;
	PropertyEPropUsageId: number;
	PropertyEpropId: number;
	PropertyId: number;
	PropertyIsBlocked: number;
	PropertyIsFreeHold: number;
	PropertyIsInfoCompleted: number;
	PropertyIsInitialManaged: number;
	PropertyIsManaged: number;
	PropertyIsRented: number;
	PropertyIsToLet: number;
	PropertyMcCompanyId?: any;
	PropertyStatusId: number;
	PropertySubTypeId: number;
	PropertyTypeId: number;
	PropertyUsageId: number;
	PropertyUsages: PropertyUsage[];
	SearchCount: number;
	SimsariNumberOfRoom: number;
	SubTypeEn: string;
	TCNumber?: any;
	TypeEn: string;
	UAENGNumber?: any;
	UsageEn: string;
	UserRefNo?: any;
}

export interface EJLookup {
	Identity: number;
	NameAr: string;
	NameEn: string;
	ParentId: number;
}

export interface OptionEJLookup extends EJLookup {
	isOwner: boolean;
}

export interface GetManagementContractDetails {
	AssociatedDetailedProperties: AssociatedDetailedProperty[];
	AgreementCompany: EJLookup;
	ContractEndDate: ServerDate;
	ManagementContractActivity: EJLookup;
	ManagementContractType: EJLookup;
	Responsibilities: Responsibilities[];
	AdditionalTerms: ContractTerm[];
	ManagementContractId: number;
	IsActivityAccepted: boolean;
}

export interface MCTerminateRequest {
	ActiveUserID: number;
	ActiveUserType: number;
	ContractId: number;
	McTerminationReasonId: number;
	TerminationDate: string;
	TerminationReasonText: string;
}

export interface MCRequest {
	ContractID: number;
	ContractNumber: string;
	ManagementCompany: EJLookup;
	ContractStatus: EJLookup;
	StartDate: ServerDate;
	EndDate: ServerDate;
	ActualTerminationDate: ServerDate;
	TerminationDate: ServerDate;
	TerminationRejectedDate: ServerDate;
	TerminationReason: EJLookup;
}

export interface ValidateMGMProperty {
	EjariPropertyID: number;
	HoldType: number;
	PropertyId: number;
	PropertyTypeId?: number;
}

export interface ValidateMGMContractRequest {
	ActiveUserID?: number;
	ActiveUserType?: number;
	ManagementCompanyId?: number;
	OwnerParticipantId?: number;
	Properties: ValidateMGMProperty[];
}

export interface ProjectProperties {
	BuildingEjariPropId?: number;
	BuildingNameAr?: string;
	BuildingNameEn?: string;
	BuildingPropertyId?: number;
	BuildingPropertyIdKey?: string;
	BuildingUnitsCount?: number;
	EjariSubTypeNameAr?: string;
	EjariSubTypeNameEn?: string;
	EjariTypeId?: number;
	EjariTypeNameAr?: string;
	EjariTypeNameEn?: string;
	IsRented?: boolean;
	IsFreeHold?: boolean;
	IsManaged?: boolean;
	LandAreaNameAr?: string;
	LandAreaNameEn?: string;
	LandAreaId?: number;
	Latitude?: number;
	Longitude?: number;
	LandPropertyId?: number;
	LandPropertyIdKey?: string;
	MoreData?: boolean;
	PropertyId?: number;
	PropertyIdKey?: string;
	PropertyNumber?: string;
	PropertyTypeId?: number;
	Rooms?: number;
	TotalPropertiesCount?: number;
	TotalRecords?: number;
	UnitPropertyId?: number;
	UnitPropertyIdKey?: string;
	VillaEjariPropId?: number;
	VillaPropertyId?: number;
	VillaPropertyIdKey?: string;
	TotalRentAmount?: number;
	RentAmount?: number;
	IsBlocked?: boolean;
	LandDmNo?: number;
	LandDmSubNo?: number;
}

export const FREE_OF_CHARGE = { Id: 1, ...LVStrings.free_of_charge };
export const PERCENTAGE = { Id: 2, ...LVStrings.percentage };
export const FIXED_AMOUNT = { Id: 3, ...LVStrings.fixed_amount };
export const ContractAmountTypes = [ FREE_OF_CHARGE, PERCENTAGE, FIXED_AMOUNT ];

export interface OwnerCompanySystem {
	Id: number;
	name: LocaleValue;
}

export enum OwnerCompany {
	OWNER = 1,
	COMPANY = 2,
}

export const OwnerSystem: OwnerCompanySystem = {
	Id: OwnerCompany.OWNER,
	name: LVStrings.owner,
};
export const CompanySystem: OwnerCompanySystem = {
	Id: OwnerCompany.COMPANY,
	name: LVStrings.company,
};

export const OCSystems: Readonly<OwnerCompanySystem[]> = [ OwnerSystem, CompanySystem ] as const;